import type { AdminI18n } from '../../i18n/admin';

// SAM-1306: the title and the button of the confirm dialog on a pass. «Confirmed» is the status the pass moves to, not
// the action: the dialog read "Confirm Confirmed" with a "Confirmed" button. The other actions are their own name.
export type PassConfirmActionType = 'Confirmed' | 'Check In' | 'Check Out' | 'Cancel';

export const confirmDialogLabels = (type: PassConfirmActionType, t: AdminI18n['t']): { title: string; button: string } => {
  if (type === 'Cancel') return { title: t('invitation.detail.cancelInvitation'), button: t('invitation.detail.cancelInvitation') };
  if (type === 'Confirmed') return { title: t('invitation.confirm.confirmTitle'), button: t('invitation.confirm.confirmButton') };
  return { title: `Confirm ${type}`, button: type };
};

/** SAM-1312 (U34): the dialog's action button is the tenant's primary colour, red only for Cancel (it was a fixed bright blue). */
export const confirmButtonColor = (type: PassConfirmActionType): string =>
  type === 'Cancel' ? '#dc3545' : 'var(--tenant-primary, #111827)';
